import { getTokenConversionMessage } from "../lib/getTokenConversionMessage";

type Props = {
  from: {
    tokenSymbol: string;
    chainId: string;
    chainName?: string;
  };
  to: {
    tokenSymbol: string;
    chainId: string;
    chainName?: string;
  };
  className?: string;
};

export function TokenConversionMessage({ from, to, className = "" }: Props) {
  const message = getTokenConversionMessage({ from, to });

  if (!message) {
    return null;
  }

  return (
    <div className={`text-xs text-[--color-text-secondary] ${className}`}>
      {message}
    </div>
  );
}
